import { useState } from 'react';

import { KycFlow } from '#src/components/kyc/KycFlow/index.tsx';

import { AccountVerificationContext } from './AccountVerification/AccountVerificationContext.tsx';
import { IdentityVerificationCTA } from './AccountVerification/IdentityVerificationCTA/index.tsx';
import { JonumVerificationInProgress } from './JonumVerificationInProgress/index.tsx';

type Props = {
  onDone: () => void;
};

export const JonumKycPromptView = ({ onDone }: Props) => {
  const [showKycFlow, setShowKycFlow] = useState(false);

  if (showKycFlow) {
    return (
      <KycFlow
        onDone={onDone}
        renderVerificationInProgress={({ onDone: onJonumDone }) => (
          <JonumVerificationInProgress onDone={onJonumDone} />
        )}
      />
    );
  }

  return (
    <AccountVerificationContext
      value={{ onSkip: onDone, updateData: () => {}, loading: false }}
    >
      <IdentityVerificationCTA onNext={() => setShowKycFlow(true)} />
    </AccountVerificationContext>
  );
};
